import { render, staticRenderFns } from "./AddNewButton.vue?vue&type=template&id=a64a70c6&scoped=true"
import script from "./AddNewButton.vue?vue&type=script&lang=js"
export * from "./AddNewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64a70c6",
  null
  
)

export default component.exports